function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEbayinline = function SvgEbayinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106.568,
    height: 40.588
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.78 8.855C6.264 8.855 0 11.886 0 21.031 0 28.276 4.212 32.84 13.974 32.84c11.49 0 12.227-7.195 12.227-7.195h-5.567s-1.194 3.874-7 3.874c-4.728 0-8.129-3.036-8.129-7.292h21.279v-2.67c0-4.21-2.812-10.7-13.004-10.7m-.194 3.413c4.5 0 7.57 2.621 7.57 6.55H5.627c0-4.17 4.006-6.55 7.958-6.55",
    style: {
      fill: "#e53238",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.346561
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.78 0v28.246c0 1.603-.12 3.855-.12 3.855h5.31s.19-1.617.19-3.095c0 0 2.624 3.902 9.758 3.902 7.513 0 12.616-4.958 12.616-12.061 0-6.608-4.687-11.922-12.604-11.922-7.412 0-9.716 3.805-9.716 3.805V0Zm13.78 12.418c5.101 0 8.345 3.6 8.345 8.429 0 5.179-3.746 8.567-8.309 8.567-5.445 0-8.382-4.041-8.382-8.521 0-4.174 2.636-8.475 8.346-8.475",
    style: {
      fill: "#0064d2",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.346561
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.732 8.855c-11.308 0-12.034 5.886-12.034 6.826h5.629s.295-3.436 6.016-3.436c3.718 0 6.6 1.618 6.6 4.728v1.107h-6.6c-8.76 0-13.391 2.436-13.391 7.38 0 4.864 4.279 7.511 10.062 7.511 7.88 0 10.42-4.14 10.42-4.14 0 1.647.133 3.27.133 3.27h5.004s-.194-2.011-.194-3.298V17.682c0-7.292-6.188-8.827-11.645-8.827m6.21 12.545v1.476c0 1.925-1.25 6.71-8.606 6.71-4.029 0-5.756-1.91-5.756-4.127 0-4.033 5.817-4.059 14.362-4.059",
    style: {
      fill: "#f5af02",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.346561
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.346 9.779h6.332l9.087 17.305 9.067-17.305h5.736L90.053 40.588h-6.017l4.766-8.589z",
    style: {
      fill: "#86b817",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.346561
    }
  }));
};
export default SvgEbayinline;